import { removeLocaleFromPath } from '@tuic/i18n';

export const getCurrentPageName = (): string => {
  return getPageName(window.location.href);
};

export const getPageName = (url: string | URL): string => {
  let instance = new URL(url);

  let host = instance.host.replaceAll('.', '_'); // 'www_meinschiff_com'
  let slug = removeLocaleFromPath(instance.pathname)
    .split('/')
    .filter(v => v.length > 0);

  if (slug.length === 0) {
    return host;
  }

  return `${host}|${slug.join('|')}`;
};
